/* ICON: country switcher behaviour, "Shopping from …?" bar and country page suggestion.
   Same file in the HU and the international theme. */
(function () {
  if (window.ICGeo) return;

  // Every ICON site. s = which Shopify store it belongs to, l = language of its texts.
  var SITES = {
    hu: { d: 'iconsports.hu', s: 'hu', l: 'hu' },
    pl: { d: 'iconsports.pl', s: 'int', l: 'en' },
    cz: { d: 'iconsports.cz', s: 'int', l: 'en' },
    sk: { d: 'iconsports.sk', s: 'int', l: 'en' },
    at: { d: 'iconsports.at', s: 'int', l: 'en' },
    si: { d: 'iconsports.si', s: 'int', l: 'en' },
    ro: { d: 'iconsports.ro', s: 'int', l: 'en' },
    dk: { d: 'iconsports.dk', s: 'int', l: 'da' }
  };

  // Visitor country → closest ICON site. iconsports.hu is only in Hungarian and only ships within Hungary,
  // so other countries go to the closest English site (Nordic countries to the Danish one).
  var GROUPS = {
    hu: 'HU',
    pl: 'PL LT LV EE BY UA RU',
    cz: 'CZ',
    sk: 'SK',
    at: 'AT DE CH LI IT SM VA MC FR BE NL LU ES PT AD IE GB IM JE GG GI MT',
    si: 'SI HR BA ME',
    ro: 'RO MD BG RS XK MK AL GR CY TR',
    dk: 'DK SE NO FI IS FO GL AX'
  };
  var FALLBACK = 'pl'; // countries outside Europe
  var MAP = {};
  Object.keys(GROUPS).forEach(function (k) { GROUPS[k].split(' ').forEach(function (c) { MAP[c] = k; }); });

  // Countries the target site actually delivers to (Shopify markets / shipping zones).
  var DELIVERS = { HU: 'hu', PL: 'pl', CZ: 'cz', SK: 'sk', AT: 'at', SI: 'si', HR: 'si', RO: 'ro', DK: 'dk' };

  var TXT = {
    en: {
      own: '<b>Shopping from {c}?</b> Order on {d}, we deliver to {c}.',
      near: '<b>Shopping from {c}?</b> Our closest shop is {d}, in English with prices in euro.',
      go: 'Go to {d}', stay: 'Stay here', close: 'Close',
      sugg: 'Suggested for you'
    },
    hu: {
      own: '<b>Magyarországról vásárolsz?</b> Az {d} oldalon forintban látod az árakat, és Magyarországra szállítunk.',
      near: '<b>Magyarországról vásárolsz?</b> Nézd meg az {d} oldalt.',
      go: 'Tovább az {d} oldalra', stay: 'Maradok itt', close: 'Bezárás',
      sugg: 'Neked ajánlott'
    },
    da: {
      own: '<b>Handler du fra {c}?</b> På {d} er alt på dansk, og vi leverer til {c}.',
      near: '<b>Handler du fra {c}?</b> Vores nærmeste butik er {d}, på dansk med priser i euro.',
      go: 'Gå til {d}', stay: 'Bliv her', close: 'Luk',
      sugg: 'Foreslået til dig'
    }
  };

  function store(kind, k, v) {
    try {
      var s = window[kind];
      if (v === undefined) return s.getItem(k);
      s.setItem(k, v);
    } catch (e) { return null; }
  }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
  function fill(t, o) { return t.replace(/\{(\w)\}/g, function (_, k) { return o[k]; }); }

  function forced() {
    var m = location.search.match(/[?&]ic_country=([A-Za-z]{2})/);
    return m ? m[1].toUpperCase() : '';
  }

  // Visitor's country code, e.g. "PL" ('' when unknown).
  function detect() {
    var f = forced();
    if (f) return Promise.resolve(f);
    var c = store('sessionStorage', 'ic-cc');
    if (c) return Promise.resolve(c);
    if (!window.fetch) return Promise.resolve('');
    return fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (j) {
        var cc = (j && j.detected_values && j.detected_values.country && j.detected_values.country.handle) || '';
        cc = String(cc).toUpperCase();
        if (cc) store('sessionStorage', 'ic-cc', cc);
        return cc;
      })
      .catch(function () { return ''; });
  }

  function siteFor(cc) { return MAP[cc] || FALLBACK; }

  function countryName(cc, lang) {
    try { return new Intl.DisplayNames([lang], { type: 'region' }).of(cc) || cc; } catch (e) { return cc; }
  }

  window.ICGeo = { SITES: SITES, MAP: MAP, TXT: TXT, detect: detect, siteFor: siteFor, countryName: countryName };

  // ---- country switcher: close on outside click / Escape, one open at a time
  document.addEventListener('click', function (e) {
    var open = document.querySelectorAll('details[data-ic-cs][open]');
    for (var i = 0; i < open.length; i++) if (!open[i].contains(e.target)) open[i].removeAttribute('open');
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelectorAll('details[data-ic-cs][open]');
    for (var i = 0; i < open.length; i++) {
      open[i].removeAttribute('open');
      var s = open[i].querySelector('summary');
      if (s) s.focus();
    }
  });

  // ---- "Shopping from …?" bar
  function bar() {
    var el = document.getElementById('ic-geo');
    if (!el) return;
    var isForced = !!forced();
    if (!isForced && store('localStorage', 'ic-geo-off') === '1') return;
    detect().then(function (cc) {
      if (!cc) return;
      var code = siteFor(cc);
      var cur = el.getAttribute('data-cur');
      if (code === cur) return;
      var t = SITES[code];
      var T = TXT[t.l];
      var own = DELIVERS[cc] === code;
      var cn = esc(countryName(cc, t.l));
      var path = el.getAttribute('data-path') || '/';
      var href = 'https://' + t.d + (t.s === el.getAttribute('data-store') ? path : '/');
      var flag = document.querySelector('.ic-cs__item[href*="' + t.d + '"] .ic-flag');
      el.innerHTML =
        '<div class="ic-geo__in">' +
          (flag ? '<span class="ic-geo__flag">' + flag.outerHTML + '</span>' : '') +
          '<p class="ic-geo__txt" lang="' + t.l + '">' + fill(own ? T.own : T.near, { c: cn, d: t.d }) + '</p>' +
          '<span class="ic-geo__acts">' +
            '<a class="ic-geo__go" href="' + href + '" lang="' + t.l + '">' + fill(T.go, { d: t.d }) +
              ' <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="M13 6l6 6-6 6"/></svg></a>' +
            '<button type="button" class="ic-geo__stay" lang="' + t.l + '">' + T.stay + '</button>' +
          '</span>' +
        '</div>';
      el.setAttribute('lang', t.l);
      el.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-in'); }); });
      el.querySelector('.ic-geo__stay').addEventListener('click', function () {
        store('localStorage', 'ic-geo-off', '1');
        el.classList.remove('is-in');
        setTimeout(function () { el.hidden = true; }, 600);
      });
    });
  }

  // ---- country page: highlight the suggested site
  function picker() {
    var root = document.querySelector('[data-ic-picker]');
    if (!root) return;
    detect().then(function (cc) {
      if (!cc) return;
      var code = siteFor(cc);
      var tile = root.querySelector('[data-site="' + code + '"]');
      if (!tile) return;
      var lang = cc === 'HU' ? 'hu' : (SITES[code].l === 'da' ? 'da' : 'en');
      tile.classList.add('is-sugg');
      var b = document.createElement('span');
      b.className = 'ic-cp__badge';
      b.setAttribute('lang', lang);
      b.textContent = TXT[lang].sugg;
      tile.appendChild(b);
      if (tile.parentNode && tile.parentNode.firstElementChild !== tile) tile.parentNode.insertBefore(tile, tile.parentNode.firstElementChild);
    });
  }

  function init() { bar(); picker(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
